import { Breadcrumb, Card, Row, Col, Label, PrimaryButton, ReactSelectBox, SofturaTable, OutlineButton, EventHandler } from "client/CommonComponents";
import TaskReset from '../../../../assets/images/TaskReset.svg'
import './AddUserBycostCenter.scss'
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import permissions, { isAuthorized } from "client/utils/Permissions";

const AddUserBycostCenter = (props?: any) => {
    const {
        handleChangeSearchedCostCenter,
        searchCostCenter,
        costCentersBySearchList,
        selectedSearchedCostCenter,
        columns,
        serverTotal,
        fetchAction,
        pagesCount,
        hideDialogComplete,
        showGrid,
        handleClickReset,
        handleChangeSearchedEmployee,
        searchEmployee,
        selectedSearchedEmployee,
        usersBySearchList,
        changedArr,
        handleSaveClick,
        handleCancelClick,
        tableData,
        PopupContent,
        breadcrumlist,
        handleClickBack,
        employeesList,
        selectedEmployee,
        handleChangeSearchEmployee,
        onCancelEmployeeClick,
        onAddEmployeeClick,
        fetchEmployeelist,
        addUserError
    } = props

    return (
        <>
        <div className="AddUsersbycostCenter">
          <div className='CustomerMyOrder breadCrumbBlock'>
            <div className='breadcrumb-toolbar'>
                <EventHandler onEvent={handleClickBack} data-attribute="AddUserByCostCenter_Default_EventHandler">
                    <div className='backButton mb-sm-2 mb-3'>
                        <span className="fa fa-chevron-left"></span>
                        Back
                    </div>
                </EventHandler>
                <div className='order-1'><Breadcrumb items={breadcrumlist} maxDisplayedItems='5'  data-attribute="AddUserByCostCenter_Default_Breadcrumb" /></div>
            </div>
            </div>
            <Card data-attribute="AddUserByCostCenter_Default_Card">
                <p className="searchedCostCenter">Add User By Cost Center</p>
                <Row>
                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                        <div >
                            <Label data-attribute="AddUserByCostCenter_Default_Label">Cost Center</Label>
                            <div className="cost-center_Reset">
                                <ReactSelectBox
                                    name='searchedCostCenter'
                                    placeholder='Search Cost Center'
                                    options={costCentersBySearchList}
                                    onChange={(value: any) => handleChangeSearchedCostCenter(value, 'searchedCostCenter')}
                                    onInputChange={searchCostCenter}
                                    value={selectedSearchedCostCenter}
                                    isSearchable={true}
                                    className='mb-3 cost-centerDD'
                                    noOptionsMessage={() => "Not Available"}
                                 data-attribute="AddUserByCostCenter_searchedCostCenter_SearchSelectBox" />
                                <EventHandler onEvent={(e: any) => handleClickReset(e)} data-attribute="AddUserByCostCenter_Default_EventHandler_2">
                                    <img src={TaskReset}
                                        className="ms-2 mt-0 mb-1 completed-reset"
                                    />
                                </EventHandler>
                            </div>
                        </div>
                    </Col>
                    {selectedSearchedCostCenter ?
                        <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                            <div>
                                <Label data-attribute="AddUserByCostCenter_Default_Label_2">Add User By Search</Label>
                                <ReactSelectBox
                                    name='searchEmployee'
                                    placeholder='Search by User name or Emp#'
                                    options={employeesList}
                                    onChange={(value: any) => handleChangeSearchEmployee(value)}
                                    onInputChange={fetchEmployeelist}
                                    value={selectedEmployee}
                                    isSearchable={true}
                                    className='cost-centerDD'
                                    noOptionsMessage={() => "Not Available"}
                                 data-attribute="AddUserByCostCenter_searchEmployee_SearchSelectBox" />
                                    {addUserError ? (
                                        <span className="costCenter-validMessage">{addUserError}</span>
                                    ) : null}
                                {selectedEmployee ? 
                                    <>
                                    <p>Home Cost Center: {selectedEmployee?.homeCostCenter ?? "-"}</p>
                                    <div className="pull-right">
                                    <OutlineButton text="Cancel" onClick={onCancelEmployeeClick} data-attribute="AddUserByCostCenter_Default_Button"></OutlineButton>
                                    <PrimaryButton text="Add" onClick={onAddEmployeeClick} disabled={!isAuthorized(permissions.Assign_Users)} data-attribute="AddUserByCostCenter_Default_Button_2"></PrimaryButton>
                                    </div>
                                    </>
                                : null}
                            </div>
                        </Col>
                        : null}
                </Row>
                <div className="SearchField">
                    <div>
                        {selectedSearchedCostCenter ?
                            <label>Cost Center : <span className="searchedCostCenter">{selectedSearchedCostCenter?.label}</span></label>
                            : null}
                    </div>
                    {showGrid?
                    <div className="pull-right datepickerControl create-flow mb-2 mb-sm-0">
                        <ReactSelectBox
                            name='searchedEmployee'
                            placeholder='Search user by Name or Employee Id'
                            options={usersBySearchList}
                            onChange={(value: any) => handleChangeSearchedEmployee(value, 'searchedEmployee')}
                            onInputChange={searchEmployee}
                            value={selectedSearchedEmployee}
                            isSearchable={true}
                            className='mb-3 cost-centerDD'
                            isClearable={true}
                            noOptionsMessage={() => "Not Available"}
                         data-attribute="AddUserByCostCenter_searchedEmployee_SearchSelectBox" />
                    </div>
                    :null}
                </div>

                <div className={`pe-0 ${tableData?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                    {showGrid ?
                        <SofturaTable
                            data={tableData ?? []}
                            columns={columns}
                            sort={true}
                            defaultPageSize={10}
                            pageSizes={[10, 20, 50]}
                            globalSearch={false}
                            className={`order-listing-grid`}
                            serverTotal={serverTotal}
                            fetchAction={fetchAction}
                            isServerSide={true}
                            pagesCount={pagesCount}
                            defaultPaginationPosition='Both'
                            fixedHeader={true}
                         data-attribute="AddUserByCostCenter_Default_Grid" />
                        : null}
                </div>
                {showGrid ?
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className='pull-right mt-3'>
                            <OutlineButton
                                    text='Cancel'
                                    className='me-2'
                                    onClick={handleCancelClick}

                                 data-attribute="AddUserByCostCenter_Default_Button_3" />
                                <PrimaryButton
                                    text='Save'
                                    onClick={handleSaveClick}
                                    disabled={changedArr.current?.length == 0 || !isAuthorized(permissions.Assign_Users)}
                                 data-attribute="AddUserByCostCenter_Default_Button_4" />
                            </div>
                            <div className='pull-right'>
                                
                            </div>

                        </Col>
                    </Row>
                    : null}

            </Card>
            <CompleteConfirmationPopup
                hideDialog={hideDialogComplete}
                onDismiss={PopupContent?.popupOutlinebtnOnclick}
                Popupcontent={PopupContent}
                popupOutlinebtnOnclick={PopupContent?.popupOutlinebtnOnclick}
                popupPrimarybtnOnclick={PopupContent?.popupPrimarybtnOnclick}
            />
            </div>
        </>
    )
}
export default AddUserBycostCenter
